// src/context/FormContext.js
import { yupResolver } from '@hookform/resolvers/yup';
import React, { createContext, useContext } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

const FormContext = createContext();

export const SolarStationFormProvider = ({ children, schema }) => {
  const methods = useForm({
    resolver: yupResolver(schema),
  });

  return (
    <FormContext.Provider value={methods}>
      <FormProvider {...methods}>{children}</FormProvider>
    </FormContext.Provider>
  );
};

export const useFormContext = () => useContext(FormContext);
